// import { storageService } from './async-storage.service'
import { httpService } from './http.service'
import { socketService } from './socket.service'

const STORAGE_KEY_LOGGEDIN_USER = 'loggedinUser'
const BASE_URL = 'user/'

export const userService = {
    login,
    logout,
    signup,
    getLoggedinUser,
    saveLocalUser,
    getUsers,
    getById,
    remove,
    update,
    setAppRole,
    setModules,
    invite,
}

window.userService = userService

// Persist a person's app-level role (which modules they can open).
function setAppRole(userId, appRole) {
    return httpService.put(BASE_URL + userId + '/role', { appRole })
}

// Persist a per-person module override (exact tabs they can see).
function setModules(userId, modules) {
    return httpService.put(BASE_URL + userId + '/modules', { modules })
}

// Invite someone by email so they can log in (creates an `invited` user record).
function invite(email) {
    return httpService.post(BASE_URL + 'invite', { email })
}

function getUsers() {
    return httpService.get(BASE_URL)
}

async function getById(userId) {
    return httpService.get(BASE_URL + userId)
}

function remove(userId) {
    return httpService.delete(BASE_URL + userId)
}

async function update({user}) {
    if (user._id) return httpService.put(BASE_URL + user._id, user)
    return httpService.post(BASE_URL, user)
}

async function login(userCred) {
    const user = await httpService.post('auth/login', userCred)
    if (user) {
        socketService.login(user._id)
        return saveLocalUser(user)
    }
}

async function signup(userCred) {
    const user = await httpService.post('auth/signup', userCred)
    socketService.login(user._id)
    return saveLocalUser(user)
}

async function logout() {
    sessionStorage.removeItem(STORAGE_KEY_LOGGEDIN_USER)
    socketService.logout()
    return await httpService.post('auth/logout')
}

function saveLocalUser(user) {
    // Keep username (email) + appRole in the session so role / super-admin checks work by EMAIL,
    // not just by full name. (The old stripped session matched super admins by name only, which
    // broke for anyone whose Google name differs from the list — e.g. "Marco Nobel" vs "marco".)
    user = { _id: user._id, fullname: user.fullname, imgUrl: user.imgUrl, username: user.username, appRole: user.appRole }
    sessionStorage.setItem(STORAGE_KEY_LOGGEDIN_USER, JSON.stringify(user))
    return user
}

function getLoggedinUser() {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY_LOGGEDIN_USER))
}




